import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import Logo from './Logo';
import logoImage from "/src/logos/logo web 4.svg";

export default function Navbar() {
  const { user, signOut } = useAuthStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg" role="navigation" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img
                src={logoImage}
                alt="CyberEdge Logo"
                className="h-16 w-auto object-contain"
                style={{
                  filter: 'brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(1789%) hue-rotate(201deg) brightness(96%) contrast(101%)'
                }}
              />
              <span className="text-2xl font-bold text-blue-900">CyberEdge</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8">
            <Link to="/solutions" className="text-blue-900 hover:text-blue-600 transition-colors duration-200">
              Solutions
            </Link>
            <Link to="/work" className="text-blue-900 hover:text-blue-600 transition-colors duration-200">
              Work
            </Link>
            <Link to="/blog" className="text-blue-900 hover:text-blue-600 transition-colors duration-200">
              Blog
            </Link>
            <Link to="/pricing" className="text-blue-900 hover:text-blue-600 transition-colors duration-200">
              Pricing
            </Link>
            <Link to="/about" className="text-blue-900 hover:text-blue-600 transition-colors duration-200">
              About
            </Link>
            {user ? (
              <>
                <Link
                  to={user.role === 'admin' ? '/admin' : '/client'}
                  className="text-blue-900 hover:text-blue-600 transition-colors duration-200"
                >
                  Dashboard
                </Link>
                <button
                  onClick={() => signOut()}
                  className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  aria-label="Sign out of your account"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-blue-900 hover:text-blue-600 transition-colors duration-200"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-blue-900 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Toggle navigation menu"
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link
              to="/solutions"
              className="block px-3 py-2 text-blue-900 hover:text-blue-600"
            >
              Solutions
            </Link>
            <Link
              to="/work"
              className="block px-3 py-2 text-blue-900 hover:text-blue-600"
            >
              Work
            </Link>
            <Link
              to="/blog"
              className="block px-3 py-2 text-blue-900 hover:text-blue-600"
            >
              Blog
            </Link>
            <Link
              to="/pricing"
              className="block px-3 py-2 text-blue-900 hover:text-blue-600"
            >
              Pricing
            </Link>
            <Link
              to="/about"
              className="block px-3 py-2 text-blue-900 hover:text-blue-600"
            >
              About
            </Link>
            {user ? (
              <>
                <Link
                  to={user.role === 'admin' ? '/admin' : '/client'}
                  className="block px-3 py-2 text-blue-900 hover:text-blue-600"
                >
                  Dashboard
                </Link>
                <button
                  onClick={() => signOut()}
                  className="block w-full text-left px-3 py-2 text-blue-900 hover:text-blue-600"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="block px-3 py-2 text-blue-900 hover:text-blue-600"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="block px-3 py-2 text-blue-900 hover:text-blue-600"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}